export { default as UserCircleSolidIcon } from './UserCircleSolidIcon';
